import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={40} height={32} viewBox="0 0 40 32" {...props}>
      <title>{"license"}</title>
      <g fill="#161657" fillRule="nonzero">
        <path d="M37 32H3c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3h34c1.654 0 3 1.346 3 3v26c0 1.654-1.346 3-3 3zM3 2a1 1 0 00-1 1v26a1 1 0 001 1h34a1 1 0 001-1V3a1 1 0 00-1-1H3z" />
        <path d="M19 8H7a1 1 0 010-2h12a1 1 0 010 2zM19 14H7a1 1 0 010-2h12a1 1 0 010 2zM19 18H7a1 1 0 010-2h12a1 1 0 010 2zM19 22H7a1 1 0 010-2h12a1 1 0 010 2zM17 26H7a1 1 0 010-2h10a1 1 0 010 2zM35.886 9.088L34.26 7.906l-.622-1.912h-2.01l-1.626-1.182-1.626 1.182h-2.01l-.622 1.912-1.626 1.182L24.74 11l-.622 1.912 1.626 1.182.264.812c-.004.032-.004.062-.004.094v10a1 1 0 001.708.708l2.292-2.292 2.292 2.292a.988.988 0 00.708.292 1 1 0 001-1V15c0-.032-.002-.064-.004-.094l.264-.812 1.626-1.182L35.268 11l.622-1.912h-.004zm-9.42.764l.976-.71.374-1.148h1.208l.976-.71.976.71h1.208l.374 1.148.976.71L33.16 11l.374 1.148-.976.71-.374 1.148h-1.208l-.976.71-.976-.71h-1.208l-.374-1.148-.976-.71L26.84 11l-.374-1.148zm4.242 11.44a1 1 0 00-1.414 0l-1.292 1.292v-6.58h.374l1.626 1.182 1.626-1.182h.374v6.58l-1.292-1.292h-.002z" />
      </g>
    </svg>
  )
}

export const LicenseIcon = React.memo(SvgComponent)

LicenseIcon.displayName = "LicenseIcon"
